import React from "react";
import AgencyForm from "./form";

const AgencyEdit = props => {
  return (
    <div className="panel panel-default">
      <div className="panel-heading">
        <h3 className="panel-title">Agency - Edit</h3>
      </div>
      <div className="panel-body">
        <AgencyForm {...props} />
      </div>
    </div>
  );
};

export default AgencyEdit;
